import { call } from 'redux-saga/effects';
import { UserRfcMeta } from 'types';

import { uploadCompanyFile } from './uploadCompanyFile';

export function* uploadCompanyRfcMeta(rfcMeta: UserRfcMeta): Generator<unknown, UserRfcMeta> {
  const { taxCertificate } = rfcMeta;

  const out: UserRfcMeta = {
    ...rfcMeta,
  };

  if (taxCertificate instanceof File) {
    out.taxCertificate = (yield call(uploadCompanyFile, { file: taxCertificate })) as string;
  }

  // preventing errors from the origin data
  out.expeditionPlace = out.expeditionPlace?.toString();
  out.taxRegime = out.taxRegime?.toString();

  return out;
}
